import React from 'react';
import { FocusDiv } from '@accedo/vdkweb-tv-ui';
import withLayout from './withLayout';

/**
 * This component is a duplica of vdkweb-tv-ui to change the default behavior
 * when moving down from the second last row. If there is nothing in below
 * the current element, the focus will be moved to the last element
 * in the last row
 */

const X = props => {
  return <FocusDiv {...props} />;
};

export default withLayout(X);
